<app-grid>
  <app-cell mobile="full:0"
              [responsiveStyle$]="{
                    base: {
                        display: 'block'
                    },
                    mobile: {
                        display: 'none'
                    }
              } | responsiveStyle$"
  >
  @if (images.length > 1) {
    <app-scroll-indicator></app-scroll-indicator>
  }
</app-cell>

<app-cell mobile="full:full" tablet="0:12">
  <div class="image-header">
    @if (images.length > 1) {
      <swiper [config]="swiperConfig">
        @for (image of images; track image) {
          <ng-template
            swiperSlide
            >
            <div class="slide"
              [class.full-size]="layout === headerLayoutEnum.FullSize"
              >
              <app-responsive-image [image]="image"
                [lazyLoad]="lazyLoad"
              ></app-responsive-image>
            </div>
          </ng-template>
        }
      </swiper>
    } @else {
      <div class="slide"
        [class.full-size]="layout === headerLayoutEnum.FullSize"
        >
        <app-responsive-image
          [image]="images[0]"
          [lazyLoad]="lazyLoad"
        ></app-responsive-image>
      </div>
      @if (title || subtitle) {
        <div
          class="text-content"
          >
          @if (title) {
            <h1>{{ title }}</h1>
          }
          @if (subtitle) {
            <p>{{ subtitle }}</p>
          }
        </div>
      }
    }
  </div>
</app-cell>
</app-grid>

